import { render, staticRenderFns } from "./AdminWebHomeSettingsScreen.vue?vue&type=template&id=6f21f311&scoped=true&"
import script from "./AdminWebHomeSettingsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminWebHomeSettingsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21f311",
  null
  
)

export default component.exports